import React from "react";

interface ValidateItem<T> {
  state: ValidateState;
  setState: React.Dispatch<React.SetStateAction<ValidateState>>;
  validate: (data: T) => boolean;
}
interface ValidateState {
  helperTextWhenError: string;
  error: boolean;
}

interface Validator {
  identifierNumber: ValidateItem<string>;
  identifierName: ValidateItem<string>;
}

const useValidator = (): Validator => {
  const [stateIdentifierNumber, setStateIdentifierNumber] =
    React.useState<ValidateState>({ error: false, helperTextWhenError: "" });
  const [stateIdentifierName, setStateIdentifierName] =
    React.useState<ValidateState>({ error: false, helperTextWhenError: "" });

  const identifierNumber: ValidateItem<string> = {
    state: stateIdentifierNumber,
    setState: setStateIdentifierNumber,
    validate: (data: string): boolean => {
      if (data !== "") {
        const re = /^\d*$/;
        if (re.test(data)) {
          // 入力あり 半角数値のみ -> OK
          const toInt = parseInt(data);
          // PostgresのIntegerの限界
          if (toInt > 2147483647) {
            setStateIdentifierNumber({
              error: true,
              helperTextWhenError:
                "数値が大きすぎます。2147483647以下の値を入力してください。",
            });
            return false;
          }
          setStateIdentifierNumber({ error: false, helperTextWhenError: "" });
          return true;
        } else {
          // 入力あり 半角数値以外の値あり -> NG
          setStateIdentifierNumber({
            error: true,
            helperTextWhenError: "半角数字のみ入力可能です。",
          });
          return false;
        }
      } else {
        // 空欄 -> OK（任意項目）
        setStateIdentifierNumber({ error: false, helperTextWhenError: "" });
        return true;
      }
    },
  };
  const identifierName: ValidateItem<string> = {
    state: stateIdentifierName,
    setState: setStateIdentifierName,
    validate: (data: string): boolean => {
      if (data !== "") {
        if (data.length > 256) {
          setStateIdentifierName({
            error: true,
            helperTextWhenError: "識別名は256文字以内で入力してください。",
          });
          return false;
        }
        setStateIdentifierName({ error: false, helperTextWhenError: "" });
        return true;
      } else {
        setStateIdentifierName({
          error: true,
          helperTextWhenError: "識別名を入力してください。",
        });
        return false;
      }
    },
  };

  return {
    identifierNumber,
    identifierName,
  };
};

export { useValidator };
